<template>
  <a-modal
    :title="$t('orders.add')"
    :width="930"
    :visible="visible"
    :key="orderNo"
    @ok="handleConfirm"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        {{ $t('common.cancelText') }}
      </a-button>
      <a-button v-show="isResetShow" key="custom" type="primary" @click="resetForm">{{ $t('buttons.reset') }}</a-button>
      <a-button :loading="isLoading" key="submit" type="primary" @click="handleConfirm">
        {{ $t('buttons.save') }}
      </a-button>
    </template>
    <a-form-model
      ref="form0"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item :label="$t('orders.code')" prop="orderNo">
        <a-input v-model="form.orderNo" />
      </a-form-model-item>
    </a-form-model>
    <a-form-model
      ref="form1"
      :label-col="{ span: 9 }"
      :wrapper-col="{ span: 15}"
      :model="form"
      :rules="rules"
      style="display: flex; justify-content: space-between"
    >
      <a-form-model-item style="width: 33%" :label="$t('orders.state')" required>
        <a-select value="0" disabled style="width: 110%">
          <a-select-option v-for="s in status" :key="s.value">
            {{ s.text }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item style="width: 33%" :label="$t('orders.type')" prop="orderType">
        <a-select v-model="form.orderType" style="width: 110%">
          <a-select-option v-for="t in types" :key="t.value">
            {{ t.text }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item style="width: 33%" :label="$t('orders.orderScore')" prop="orderScore">
        <a-input v-model="form.orderScore" />
      </a-form-model-item>
    </a-form-model>
    <a-form-model
      v-if="isDeviceShow"
      ref="form2"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item :label="$t('orders.finishTime')" prop="finishTime">
        <a-date-picker @change="selectFinishTime" style="width: 100%" show-time />
      </a-form-model-item>
      <a-form-model-item :label="$t('configuration.device')" prop="deviceId">
        <a-select
          v-model="form.deviceId"
          show-search
          :disabled="isDeviceDisabled"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          @inputKeydown="searchDevice"
          @popupScroll="handleDevicePopupScroll"
          @change="isCustomerDisabled = true"
        >
          <a-select-option @click.native="selectDevice(d)" v-for="d in devices" :key="d.id">
            {{ d.name }} - {{ d.code }} - {{ d.model }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <a-form-model
      ref="form3"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item :label="$t('common.customer')" prop="customerId">
        <a-select
          v-model="form.customerId"
          show-search
          :disabled="isDeviceDisabled || isCustomerDisabled"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          @inputKeydown="searchCustomer"
          @popupScroll="handleCustomerPopupScroll"
          @change="form.deviceId = ''; devices = []"
        >
          <a-select-option v-for="c in customers" :key="c.id">
            {{ c.company }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('common.remark')">
        <a-textarea v-model="form.note" :rows="2" />
      </a-form-model-item>
    </a-form-model>
    <!-- <a-form-model
      :label-col="{ span: 12 }"
      :wrapper-col="{ span: 12 }"
      style="display: flex; flex-wrap: wrap"
      class="group"
    >
      <div style="width: 50%; display: flex; justify-content: space-between;" class="inline">
        <a-form-model-item style="width: 50%" label="接单人：">
          <a-select
            v-model="receiverId"
            show-search
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            @inputKeydown="searchUser"
          >
            <a-select-option @click.native="selectUser(u)" v-for="u in users" :key="u.userId">
              {{ u.userName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="width: 50%" label="积分占比：">
          <a-input />
        </a-form-model-item>
      </div>
      <div
        v-for="(h, i) in helpers"
        :key="h.id"
        style="width: 50%; display: flex; justify-content: space-between;"
        class="inline"
      >
        <a-form-model-item style="width: 50%" label="协助人：">
          <a-tooltip>
            <template slot="title">删除</template>
            <a-icon
              type="minus-square"
              style="position: absolute; left: -80px; top: 2px; cursor: pointer; font-size: 16px"
              @click="removeHelper(i)"
            />
          </a-tooltip>
          <a-select>
            <a-select-option value="Pending">岑丰科</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="width: 50%" label="积分占比：">
          <a-input />
        </a-form-model-item>
      </div>
    </a-form-model> -->
    <!-- <a-button @click="addHelpers" type="primary" icon="plus" style="margin-left: 40px" /> -->
  </a-modal>
</template>

<script>
import { getDict } from '@/api/dict'
import { searchCustomerList, getCustomerById } from '@/api/customer'
import { searchDeviceList } from '@/api/device'
import {
  addOrder
} from '@/api/order'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    closeModal: {
      type: Function,
      required: true
    },
    orderNo: {
      type: String,
      default: ''
    },
    deviceId: {
      type: Number,
      default: 0
    },
    customerId: {
      type: Number,
      default: 0
    },
    isDeviceDisabled: {
      type: Boolean,
      default: false
    },
    isResetShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      helpers: [
        {
          id: 0
        }
      ],
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
      types: [],
      status: [],
      form: {
        orderNo: '',
        orderType: '',
        orderScore: '',
        finishTime: '',
        customerId: '',
        deviceId: '',
        note: ''
      },
      users: [],
      rules: {
        orderNo: [
          {
            required: true,
            message: this.$t('messages.orderNo'),
            trigger: 'blur'
          }
        ],
        orderType: [
          {
            required: true,
            message: this.$t('messages.orderType')
          }
        ],
        orderScore: [
          {
            required: true,
            message: this.$t('messages.orderScore'),
            trigger: 'blur'
          }
        ],
        finishTime: [
          {
            required: true,
            message: this.$t('messages.finishTime')
          }
        ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.customerId')
          }
        ],
        deviceId: [
          {
            required: true,
            message: this.$t('messages.deviceId')
          }
        ]
      },
      finishTime: '',
      customers: [],
      devices: [],
      isLoading: false,
      isCustomerDisabled: false,
      isDeviceShow: true
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    orderNo(v) {
      this.form.orderNo = v
      if (v) {
        if (this.deviceId) {
          this.setDeviceId(this.deviceId)
        }
        if (this.customerId) {
          this.setCustomerId(this.customerId)
        }
      }
    },
    isDeviceShow(v) {
      if (!v) {
        this.$nextTick(() => {
          this.isDeviceShow = true
        })
      }
    },
    lang() {
      this.getTypesAndStatus()
    }
  },
  created() {
    this.getTypesAndStatus()
    this.cSearchFlag = true
    this.dSearchFlag = true
    this.customerPage = this.devicePage = 1
    this.cs = this.ds = ''
  },
  methods: {
    async setDeviceId(value) {
      const { data } = await searchDeviceList(1, 10, {
        query: [],
        filter: [
          {
            field: 'id',
            value 
          }
        ],
        sort: []
      })
      const d = data.records[0]
      this.form.deviceId = d.id
      this.devices = [d]
    },
    async setCustomerId(value) {
      const { data } = await getCustomerById(value)
      this.form.customerId = data.id
      this.customers = [data]
    },
    addHelpers() {
      this.helpers.push({
        id: nanoid()
      })
    },
    removeHelper(i) {
      this.helpers.splice(i, 1)
    },
    handleCancel() {
      this.closeModal(false)
      this.clearForm()
      this.customers = []
      this.devices = []
    },
    async getTypesAndStatus() {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      try {
        const { data: { content } } = await getDict(lang, 'afterSaleServerItem')
        this.types = content
        const state = await getDict(lang, 'afterSaleOrderStatus')
        this.status = state.data.content
      } catch(e) {
        console.log(e)
      }
    },
    selectFinishTime(_, b) {
      this.form.finishTime = b
    },
    async searchCustomer(e) {
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        e.target.value = e.target.value.trim()
        this.cs = e.target.value
        this.cSearchFlag = true
        this.customerPage = 1
        try {
          const { data } = await searchCustomerList(1, 10, {
            query: [
              {
                field: 'company',
                value: this.cs
              }
            ],
            filter: [],
            sort: []
          })
          this.customers = data.records
        } catch(e) {
          console.log(e)
        }
      }
    },
    async searchDevice(e) {
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        e.target.value = e.target.value.trim()
        this.ds = e.target.value
        this.dSearchFlag = true
        this.devicePage = 1
        const params = {
          query: [
            {
              field: 'code',
              value: this.ds
            }
          ],
          filter: [],
          sort: []
        }
        if (this.form.customerId) {
          params.filter = [
            {
              field: 'customerId',
              value: this.form.customerId
            }
          ]
        }
        try {
          const { data } = await searchDeviceList(1, 10, params)
          this.devices = data.records
        } catch(e) {
          console.log(e)
        }
      }
    },
    async handleCustomerPopupScroll(e){
      if (this.cSearchFlag) {
        const { scrollHeight, scrollTop, clientHeight } = e.target
        if(scrollHeight - scrollTop === clientHeight){
          this.customerPage++
          const { data } = await searchCustomerList(this.customerPage, 10, {
            query: [
              {
                field: 'company',
                value: this.cs
              }
            ],
            filter: [],
            sort: []
          })
          this.customers = this.customers.concat(data.records)
          if (this.customers.length >= data.total) {
            this.cSearchFlag = false
          }
        }
      }
    },
    async handleDevicePopupScroll(e){
      if (this.dSearchFlag) {
        const { scrollHeight, scrollTop, clientHeight } = e.target
        if(scrollHeight - scrollTop === clientHeight){
          this.devicePage++
          const params = {
            query: [
              {
                field: 'code',
                value: this.ds
              }
            ],
            filter: [],
            sort: []
          }
          if (this.form.customerId) {
            params.filter = [
              {
                field: 'customerId',
                value: this.form.customerId
              }
            ]
          }
          const { data } = await searchDeviceList(this.devicePage, 10, params)
          this.devices = this.devices.concat(data.records)
          if (this.devices.length >= data.total) {
            this.dSearchFlag = false
          }
        }
      }
    },
    async handleConfirm() {
      let f = true
      for (let i = 0; i < 4; i++) {
        this.$refs[`form${i}`].validate(valid => f && (f = valid))
      }
      if (f) {
        this.isLoading = true
        try {
          const { message } = await addOrder(this.form)
          this.$message.success(message)
          this.closeModal(true)
          this.customers = []
          this.devices = []
          this.clearForm()
        } catch(e) {
          console.log(e)
        } finally {
          this.isLoading = false
        }
      }
    },
    clearForm() {
      this.form = {
        orderNo: '',
        orderType: '',
        orderScore: '',
        finishTime: '',
        customerId: '',
        deviceId: '',
        note: ''
      }
      this.isCustomerDisabled = false
    },
    selectDevice(d) {
      this.customers = [d.customer]
      this.form.customerId = d.customerId
    },
    resetForm() {
      this.customers = []
      this.devices = []
      this.isCustomerDisabled = false
      this.form.customerId = ''
      this.form.deviceId = ''
      this.isDeviceShow = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-form {
  padding-bottom: 0;
  &.inline {
    .ant-form-item:last-child .ant-form-item-label {
      width: 15%;
      margin-right: 6px;
    }
  }
}
/deep/ .ant-modal-body {
  padding-bottom: 20px;
  padding-right: 60px;
}
</style>